import { PufferfishException } from './pufferfish-exception'

export class Auth0InvalidAuthorizationParamsException extends PufferfishException {
    public constructor() {
        super(undefined, Auth0InvalidAuthorizationParamsException)
    }
}
